import { doc, setDoc, getDoc, getFirestore } from 'firebase/firestore';
import { COLLECTIONS } from '../constants';
import { auth } from './firebaseConfig.ts';

const db = getFirestore();

export const createUserProfile = async (id: string) => {
  if (!auth.currentUser) throw new Error('User is not logged in');

  const userRef = doc(db, COLLECTIONS.users, auth.currentUser.uid);
  const userSnap = await getDoc(userRef);

  if (!userSnap.exists()) {
    await setDoc(userRef, {
      email: auth.currentUser.email,
      displayName: auth.currentUser.displayName || '',
      phoneNumber: auth.currentUser.phoneNumber,
      createdAt: new Date(),
    });
  }
};
